import type { LegalCopy } from '../types'

export const or: LegalCopy = {
  title: 'ଆଇନଗତ ସହାୟତା',
  subtitle: 'ସାଧାରଣ ଆଇନଗତ ସମସ୍ୟା, ସହଜ କଥାରେ ବୁଝାଯାଇଛି। ନିଜ ଭାଷାରେ ଶୁଣନ୍ତୁ, ଏବଂ ପ୍ରତ୍ୟେକ ଉତ୍ତରର ସରକାରୀ ଉତ୍ସ ଦେଖନ୍ତୁ।',
  helplinesTitle: 'ହେଲ୍ପଲାଇନ (ମାଗଣା କଲ୍)',
  helplines: {
    emergency: 'ଜରୁରୀକାଳୀନ: ପୋଲିସ, ଅଗ୍ନିଶମ, ଆମ୍ବୁଲାନ୍ସ',
    legal_aid: 'ମାଗଣା ଆଇନଗତ ସହାୟତା (NALSA)',
    cyber: 'ଅନଲାଇନ / UPI ଠକେଇ',
    women: 'ମହିଳା ହେଲ୍ପଲାଇନ',
    consumer: 'ଉପଭୋକ୍ତା ହେଲ୍ପଲାଇନ'
  },
  faqTitle: 'ସାଧାରଣ ପ୍ରଶ୍ନ',
  searchPlaceholder: 'ଖୋଜନ୍ତୁ: FIR, ଠକେଇ, RTI, ଓକିଲ…',
  noMatch: 'କୌଣସି ପ୍ରଶ୍ନ ମେଳ ଖାଇଲା ନାହିଁ। ତଳେ ନିଜ ପ୍ରଶ୍ନ ପଚାରନ୍ତୁ।',
  sources: 'ସରକାରୀ ଉତ୍ସ',
  listen: 'ଶୁଣନ୍ତୁ',
  askTitle: 'ନିଜର ଆଇନଗତ ପ୍ରଶ୍ନ ପଚାରନ୍ତୁ',
  askHint: 'ସମଝୋ କେବଳ ସରକାରୀ ୱେବସାଇଟରୁ ଉତ୍ତର ଦିଏ, ଉତ୍ସର ଲିଙ୍କ ସହିତ।',
  starters: ['ମୋତେ କ’ଣ ମାଗଣା ଓକିଲ ମିଳିପାରିବ?', 'କେହି ମୋତେ ଅନଲାଇନରେ ଠକିଛି। ମୁଁ କ’ଣ କରିବି?', 'ପୋଲିସ ମୋ ଅଭିଯୋଗ ଲେଖୁନାହିଁ। ମୁଁ କ’ଣ କରିପାରିବି?'],
  disclaimer:
    'ଏହା ସରକାରୀ ଉତ୍ସରୁ ନିଆଯାଇଥିବା ସାଧାରଣ ସୂଚନା, ଆପଣଙ୍କ ମାମଲା ପାଇଁ ଆଇନଗତ ପରାମର୍ଶ ନୁହେଁ। ନିଜ ମାମଲା ପାଇଁ ଜଣେ ଓକିଲଙ୍କ ସହ କଥା ହୁଅନ୍ତୁ — ଆଇନ ସେବା ପ୍ରାଧିକରଣ (15100)ରୁ ଆପଣ ମାଗଣାରେ ଓକିଲ ପାଇପାରନ୍ତି।',
  topics: {
    get_free_aid: {
      q: 'ମାଗଣା ଆଇନଗତ ସହାୟତା କିପରି ପାଇବି?',
      a: 'NALSAର ମାଗଣା ହେଲ୍ପଲାଇନ 15100 ନମ୍ବରକୁ କଲ୍ କରନ୍ତୁ। କିମ୍ବା ଆପଣଙ୍କ ଜିଲ୍ଲା କୋର୍ଟରେ ଥିବା ଆଇନ ସେବା ପ୍ରାଧିକରଣ ଅଫିସକୁ, ବା ତାଲୁକା କୋର୍ଟରେ ଥିବା ଆଇନ ସେବା କମିଟି ପାଖକୁ ଯାଆନ୍ତୁ। ଆପଣ ଅନଲାଇନରେ, ଡାକ ଯୋଗେ କିମ୍ବା ଇ-ମେଲ ଯୋଗେ ମଧ୍ୟ ଆବେଦନ କରିପାରିବେ। ଫର୍ମ ମାଗଣା, ଏବଂ ଓକିଲଙ୍କ ଫି ଓ କୋର୍ଟ ଖର୍ଚ୍ଚ ଆପଣଙ୍କ ପାଇଁ ଦିଆଯାଏ।'
    },
    who_free_aid: {
      q: 'କିଏ ମାଗଣା ଓକିଲ ପାଇପାରିବେ?',
      a: 'ଆଇନ (ଆଇନ ସେବା ପ୍ରାଧିକରଣ ଅଧିନିୟମର ଧାରା 12) ଏମାନଙ୍କୁ ମାଗଣା ଆଇନଗତ ସହାୟତା ଦିଏ: ମହିଳା ଓ ଶିଶୁ, SC/ST ବର୍ଗର ଲୋକ, ଭିନ୍ନକ୍ଷମ ବ୍ୟକ୍ତି, ଶିଳ୍ପ ଶ୍ରମିକ, ମଣିଷ ଚାଲାଣ କିମ୍ବା ବେଠି (ଜବରଦସ୍ତି ଶ୍ରମ)ର ଶିକାର, ବିପର୍ଯ୍ୟୟ, ଜାତିଗତ ଅତ୍ୟାଚାର କିମ୍ବା ଗୋଷ୍ଠୀଗତ ହିଂସାର ଶିକାର, ହେପାଜତରେ ଥିବା ଲୋକ, ଏବଂ ଯେଉଁମାନଙ୍କ ବାର୍ଷିକ ଆୟ ସେମାନଙ୍କ ରାଜ୍ୟ ଧାର୍ଯ୍ୟ କରିଥିବା ସୀମାଠାରୁ କମ୍। ଆୟ ସୀମା ପ୍ରତ୍ୟେକ ରାଜ୍ୟରେ ଅଲଗା।'
    },
    fir: {
      q: 'ପୋଲିସ ମୋ FIR ଲେଖୁନାହିଁ। ମୁଁ କ’ଣ କରିବି?',
      a: 'ଗୁରୁତର (ସଂଜ୍ଞେୟ) ଅପରାଧ ବିଷୟରେ ଆପଣ ଯେକୌଣସି ଥାନାରେ ଜଣାଇପାରିବେ, ଅପରାଧ ଅନ୍ୟ କେଉଁଠି ଘଟିଥିଲେ ମଧ୍ୟ — ଏହାକୁ ଜିରୋ FIR କୁହାଯାଏ। ପୋଲିସକୁ ଆପଣଙ୍କୁ FIRର ଏକ କପି ମାଗଣାରେ ଦେବାକୁ ହିଁ ପଡ଼ିବ। ପୋଲିସ ମନା କଲେ, ଆପଣଙ୍କ ଅଭିଯୋଗ ଲେଖି ଡାକ ଯୋଗେ ପୋଲିସ ଅଧୀକ୍ଷକ (SP)ଙ୍କ ପାଖକୁ ପଠାନ୍ତୁ। SP ମଧ୍ୟ କିଛି ନକଲେ, ଆପଣ ଏକ ସତ୍ୟପାଠ (ଆଫିଡେଭିଟ) ସହ ମାଜିଷ୍ଟ୍ରେଟଙ୍କ ପାଖରେ ଆବେଦନ କରିପାରିବେ।'
    },
    cyber_fraud: {
      q: 'ଅନଲାଇନ କିମ୍ବା UPI ଠକେଇରେ ମୋ ଟଙ୍କା ଚାଲିଗଲା। କ’ଣ କରିବି?',
      a: 'ତୁରନ୍ତ 1930 ନମ୍ବରକୁ କଲ୍ କରନ୍ତୁ — ଏହା ଜାତୀୟ ସାଇବର କ୍ରାଇମ ହେଲ୍ପଲାଇନ, ମାଗଣା, ଦିନରାତି ଚାଲୁ ରହେ। ଶୀଘ୍ର ଜଣାଇଲେ ଟଙ୍କା ଅନ୍ୟତ୍ର ପଠାଇ ଦିଆଯିବାକୁ ରୋକିବାରେ ସାହାଯ୍ୟ ହୁଏ। ଏହା ସହ cybercrime.gov.in ୱେବସାଇଟରେ “Financial Fraud” ଭାଗରେ ଅଭିଯୋଗ କରନ୍ତୁ।'
    },
    women: {
      q: 'ଜଣେ ମହିଳା ହିଂସା ବା ହଇରାଣର ଶିକାର ହେଉଛନ୍ତି। ସେ କେଉଁଠି ସାହାଯ୍ୟ ପାଇବେ?',
      a: 'ଜରୁରୀ ଅବସ୍ଥାରେ ପୋଲିସ, ଅଗ୍ନିଶମ କିମ୍ବା ଆମ୍ବୁଲାନ୍ସ ପାଇଁ 112 ନମ୍ବର ଡାଏଲ କରନ୍ତୁ। ମାଗଣା ମହିଳା ହେଲ୍ପଲାଇନ 181 ନମ୍ବରକୁ ଦିନ କି ରାତି ଯେକୌଣସି ସମୟରେ କଲ୍ କରନ୍ତୁ। ଆପଣ ନିଜ ନାମ ଗୋପନ ରଖିପାରିବେ, ଏବଂ ଏହା ଆପଣଙ୍କୁ ପୋଲିସ, ୱାନ ଷ୍ଟପ ସେଣ୍ଟର, ଡାକ୍ତରଖାନା କିମ୍ବା ଆଇନଗତ ସହାୟତା ସହ ଯୋଡ଼ିଦିଏ। ଜାତୀୟ ମହିଳା ଆୟୋଗର ମଧ୍ୟ ଏକ ହେଲ୍ପଲାଇନ ଅଛି, 14490, ଏବଂ ଆୟୋଗ ଅନଲାଇନରେ ଅଭିଯୋଗ ମଧ୍ୟ ନିଏ।'
    },
    consumer: {
      q: 'କୌଣସି ଦୋକାନ କିମ୍ବା କମ୍ପାନୀ ମୋତେ ଠକିଛି। କେଉଁଠି ଅଭିଯୋଗ କରିବି?',
      a: 'ଜାତୀୟ ଉପଭୋକ୍ତା ହେଲ୍ପଲାଇନ 1915 ନମ୍ବରକୁ କଲ୍ କରନ୍ତୁ (ମାଗଣା, ସକାଳ 8ଟାରୁ ରାତି 8ଟା ପର୍ଯ୍ୟନ୍ତ), 8800001915 ନମ୍ବରକୁ WhatsApp ମେସେଜ ପଠାନ୍ତୁ, କିମ୍ବା consumerhelpline.gov.in ୱେବସାଇଟରେ ଅଭିଯୋଗ କରନ୍ତୁ। ଉପଭୋକ୍ତା ଆୟୋଗରେ ମାମଲା ଦାୟର କରିବାକୁ ହେଲେ, e-Daakhil ରେ ଅନଲାଇନରେ କରିପାରିବେ।'
    },
    summons: {
      q: 'ମୁଁ କୋର୍ଟର ସମନ ପାଇଛି। କ’ଣ କରିବି?',
      a: 'ସମନରେ ଲେଖାଥାଏ ଯେ ଆପଣଙ୍କୁ କେଉଁ ତାରିଖରେ କୋର୍ଟକୁ ଆସିବାକୁ ହେବ। ଆପଣ ଯୋଗ୍ୟ ହୋଇଥିଲେ, ମାମଲାର ଯେକୌଣସି ପର୍ଯ୍ୟାୟରେ ମାଗଣା ଓକିଲ ପାଇପାରିବେ: 15100 ନମ୍ବରକୁ କଲ୍ କରନ୍ତୁ କିମ୍ବା ଆପଣଙ୍କ ଜିଲ୍ଲା କୋର୍ଟରେ ଥିବା ଆଇନ ସେବା ଅଫିସକୁ ଯାଆନ୍ତୁ। ଆପଣଙ୍କ ମାମଲା ଏବଂ ତାର ପରବର୍ତ୍ତୀ ତାରିଖ eCourts ୱେବସାଇଟ କିମ୍ବା ଆପରେ ଦେଖିପାରିବେ।'
    },
    case_status: {
      q: 'ମୋ କୋର୍ଟ ମାମଲାର ସ୍ଥିତି (ଷ୍ଟାଟସ) କିପରି ଦେଖିବି?',
      a: 'services.ecourts.gov.in ୱେବସାଇଟକୁ ଯାଆନ୍ତୁ, କିମ୍ବା eCourts ସର୍ଭିସେସ ଆପ ବ୍ୟବହାର କରନ୍ତୁ, ଏବଂ ଆପଣଙ୍କ 16 ଅଙ୍କର CNR ନମ୍ବର କିମ୍ବା ମାମଲାର ଅନ୍ୟ ବିବରଣୀ ଦେଇ ଖୋଜନ୍ତୁ। ଆପଣ ଏସଏମଏସ ମଧ୍ୟ ପଠାଇପାରିବେ: ECOURTS, ତା’ପରେ ଏକ ସ୍ପେସ, ତା’ପରେ ଆପଣଙ୍କ CNR ନମ୍ବର ଲେଖି 9766899899 ନମ୍ବରକୁ ପଠାନ୍ତୁ।'
    },
    lok_adalat: {
      q: 'ଲୋକ ଅଦାଲତ କ’ଣ?',
      a: 'ଲୋକ ଅଦାଲତ ଦୁଇ ପକ୍ଷର ସହମତିରେ ମାମଲାର ସମାଧାନ କରେ। ଏଥିରେ କୌଣସି କୋର୍ଟ ଫି ଲାଗେ ନାହିଁ, ଏବଂ କୋର୍ଟରେ ଆଗରୁ ଚାଲିଥିବା ମାମଲା ଏଠାରେ ସମାଧାନ ହେଲେ, ଆପଣ ଦେଇଥିବା କୋର୍ଟ ଫି ଫେରସ୍ତ ଦିଆଯାଏ। ଏହାର ନିଷ୍ପତ୍ତି କୋର୍ଟର ଡିକ୍ରି ଭଳି ଚୂଡ଼ାନ୍ତ, ଏବଂ ଏହାକୁ ମାନିବାକୁ ହିଁ ପଡ଼ିବ। ଏହା ବିରୁଦ୍ଧରେ କୌଣସି ଅପିଲ କରିହେବ ନାହିଁ।'
    },
    rti: {
      q: 'RTI କିପରି ଦାଖଲ କରିବି?',
      a: 'କେନ୍ଦ୍ର ସରକାରଙ୍କ ଅଫିସ ପାଇଁ rtionline.gov.in ୱେବସାଇଟରେ ଅନଲାଇନ ଆବେଦନ କରନ୍ତୁ। ଫି ₹10; ଆପଣ ଦାରିଦ୍ର୍ୟ ସୀମାରେଖା ତଳେ ଥିଲେ କୌଣସି ଫି ଲାଗିବ ନାହିଁ (ଆପଣଙ୍କ BPL ପ୍ରମାଣପତ୍ର ସଂଲଗ୍ନ କରନ୍ତୁ)। ଅଧିକାରୀଙ୍କୁ 30 ଦିନ ମଧ୍ୟରେ ଉତ୍ତର ଦେବାକୁ ହେବ, ଏବଂ କାହାର ଜୀବନ କିମ୍ବା ସ୍ୱାଧୀନତା ସମ୍ପର୍କିତ ବିଷୟ ହେଲେ 48 ଘଣ୍ଟା ମଧ୍ୟରେ। 30 ଦିନରେ ଉତ୍ତର ନମିଳିଲେ, ପରବର୍ତ୍ତୀ 30 ଦିନ ମଧ୍ୟରେ ମାଗଣାରେ ପ୍ରଥମ ଅପିଲ କରିପାରିବେ।'
    },
    grievance: {
      q: 'ସରକାରୀ ଅଫିସ ମୋ କାମ କରୁନାହିଁ। କେଉଁଠି ଅଭିଯୋଗ କରିବି?',
      a: 'pgportal.gov.in ୱେବସାଇଟରେ CPGRAMSରେ ଅଭିଯୋଗ ଦାଖଲ କରନ୍ତୁ — ଏହା ଦିନରାତି ଖୋଲା ରହେ (ଏହାର ଆପରେ ଓ UMANGରେ ମଧ୍ୟ କରିହେବ)। 21 ଦିନ ମଧ୍ୟରେ ସମାଧାନ କରିବାର ଲକ୍ଷ୍ୟ ରଖାଯାଇଛି। ଏଥିରେ RTI ବିଷୟ, କୋର୍ଟ ମାମଲା, ଧାର୍ମିକ ବିଷୟ କିମ୍ବା ସରକାରୀ କର୍ମଚାରୀଙ୍କ ଚାକିରି ସମ୍ପର୍କିତ ବିଷୟ ନିଆଯାଏ ନାହିଁ।'
    }
  }
}
